<div class="nav-item-container">
  <div
    appThrottleClick
    (throttleClick)="navItemSelected()"
    [class.active]="viewModel.isNavItemActive$ | async"
    [class.animating]="animating$ | async"
    [ngbTooltip]="collapsed ? navItem.name : null"
    [placement]="'right'"
    class="nav-item bs-nav-item">
    <div class="nav-item-icon">
      <img [src]="navItem.iconSrc" alt="icon" class="nav-bar-icon" />
      <img [src]="navItem.iconFilledSrc" alt="icon-filled" class="nav-bar-icon-filled" />
    </div>
    <div *rxIf="!collapsed" class="nav-item-label" [class.multi-line-label]="viewModel.multiLineNavItem$ | async">
      {{ navItem.name }}
    </div>
    <div *rxIf="!collapsed && (viewModel.hasNotifications$ | async)" class="nav-item-notification-pill">
      {{ viewModel.notificationsCount$ | async }}
    </div>
  </div>
  <app-sidebar-sub-item-list
    *rxIf="!collapsed && navItem?.subItems?.length > 1"
    #subList
    class="sub-list"
    [navItem]="navItem"
    [currentNavUrl]="currentNavUrl"
    [style.height.px]="(viewModel.isNavItemActive$ | async) ? (subList | method: 'getListScrollHeight') : 0">
  </app-sidebar-sub-item-list>
</div>
